import { injectable } from "inversify";
import { Message, Field, Type } from "protobufjs/light";
import { Result, ok } from "@xlearn/common";
import * as Api from "@/app/state-serialization/api";
import { HotspotAnswer, Spot, SpotState } from "./hotspot-interfaces";
import { ProtobufSerializer } from "@/app/state-serialization/infrastructure";

@injectable()
export class HotspotQuestionAnswerProtobufSerializer
  implements Api.StateSerializationPlugin<HotspotAnswer> {
  key = {
    id: 22,
    name: { ns: "suspend-data", name: "question-answer-hotspot" },
    format: "protobuf"
  };

  serialize(data: HotspotAnswer): Result<Uint8Array, Api.SerializerError> {
    const message = new HotspotAnswerProtoMessage({
      indices: data.indices,
      markers: data.markers.map(
        marker => new HotspotAnswerMarkerSpotProtoMessage(marker)
      )
    });

    return ProtobufSerializer.serialize<HotspotAnswerProtoMessage>(
      message,
      HotspotAnswerProtoMessage
    );
  }

  deserialize(
    content: Uint8Array
  ): Result<HotspotAnswer, Api.DeserializerError> {
    const deserializeResult = ProtobufSerializer.deserialize<
      HotspotAnswerProtoMessage
    >(content, HotspotAnswerProtoMessage);
    if (!deserializeResult.success) {
      return deserializeResult;
    }

    const message = deserializeResult.value;
    const result: HotspotAnswer = {
      indices: message.indices,
      markers: message.markers.map(marker => ({
        x: marker.x,
        y: marker.y,
        state: marker.state,
      }))
    };

    return ok(result);
  }
}

@Type.d("HotspotAnswerMarkerSpotProtoMessage")
class HotspotAnswerMarkerSpotProtoMessage extends Message<
  HotspotAnswerMarkerSpotProtoMessage
> {
  @Field.d(1, "float", "optional", 0)
  x: number;

  @Field.d(2, "float", "optional", 0)
  y: number;

  @Field.d(3, "string", "optional", "")
  state: SpotState;
}

@Type.d("HotspotAnswerProtoMessage")
class HotspotAnswerProtoMessage extends Message<HotspotAnswerProtoMessage> {
  @Field.d(1, "uint32", "repeated")
  indices: number[];

  @Field.d(2, HotspotAnswerMarkerSpotProtoMessage, "repeated")
  markers: Spot[];
}
